import React, { useState } from 'react';

const GRP_VGL_CSS = `
.grp-vgl{
  --primair:var(--color-primary,#2D5A27); --primair-licht:#EAF1E8; --primair-zacht:#F4F8F3; --primair-donker:#1F4019;
  --tekst:var(--color-foreground,#1A1D23); --gedempt:var(--color-muted-foreground,#6B7280); --rand:var(--color-border,#E5E7EB);
  --wit:#FFFFFF; --accent:var(--color-accent,#F4A261);
  --kop:Inter,system-ui,sans-serif; --body:"Source Sans Pro",system-ui,sans-serif;
  position:relative; overflow:hidden;
  background:linear-gradient(180deg,#F9FAFB 0%,var(--primair-zacht) 55%,#F9FAFB 100%);
  color:var(--tekst); font:400 15px/1.55 var(--body); padding:80px 16px; box-sizing:border-box;
  border-top:1px solid var(--rand); border-bottom:1px solid var(--rand);
}
.grp-vgl::before{content:"";position:absolute;top:-140px;right:-120px;width:420px;height:420px;border-radius:50%;background:radial-gradient(circle,rgba(45,90,39,.10) 0%,rgba(45,90,39,0) 70%);pointer-events:none}
.grp-vgl::after{content:"";position:absolute;bottom:-160px;left:-140px;width:460px;height:460px;border-radius:50%;background:radial-gradient(circle,rgba(30,58,95,.07) 0%,rgba(30,58,95,0) 70%);pointer-events:none}
.grp-vgl *{box-sizing:border-box}
.grp-vgl .binnen{position:relative;z-index:1;max-width:1000px;margin:0 auto}
.grp-vgl .label{display:inline-block;margin:0 0 18px;padding:6px 12px;border-radius:999px;background:rgba(45,90,39,.10);font:600 12px/1.2 var(--kop);letter-spacing:.08em;text-transform:uppercase;color:var(--primair)}
.grp-vgl h2{margin:0 0 16px;font:700 clamp(28px,4vw,38px)/1.15 var(--kop);letter-spacing:-.015em;max-width:26em;color:var(--tekst)}
.grp-vgl .intro{margin:0 0 32px;max-width:44em;font-size:17px;line-height:1.65;color:var(--gedempt)}
.grp-vgl .schuif{position:relative;background:linear-gradient(135deg,var(--primair) 0%,var(--primair-donker) 100%);color:#fff;border-radius:20px;padding:24px 28px;margin:0 0 20px;box-shadow:0 12px 32px rgba(45,90,39,.28),0 2px 6px rgba(0,0,0,.08)}
.grp-vgl .schuif label{display:block;font:700 18px/1.25 var(--kop);margin:0 0 4px;color:#fff}
.grp-vgl .schuif .uit{margin:0 0 16px;color:rgba(255,255,255,.78);font-size:14px}
.grp-vgl .schuif .rij-schuif{display:flex;align-items:center;gap:16px}
.grp-vgl .schuif output{font:700 22px/1 var(--kop);min-width:5.5em;text-align:right;font-variant-numeric:tabular-nums;color:#fff;background:rgba(255,255,255,.14);padding:10px 12px;border-radius:12px}
.grp-vgl input[type=range]{flex:1;accent-color:var(--accent);height:28px;margin:0;cursor:pointer}
.grp-vgl .kaart{margin:0;background:var(--wit);border:1px solid var(--rand);border-radius:20px;padding:32px;box-shadow:0 10px 30px rgba(26,29,35,.08),0 2px 6px rgba(26,29,35,.04)}
.grp-vgl .kaart h3{margin:0 0 4px;font:700 20px/1.25 var(--kop);color:var(--tekst)}
.grp-vgl .sub{margin:0 0 24px;color:var(--gedempt);font-size:14px}
.grp-vgl ol{list-style:none;margin:0;padding:0}
.grp-vgl li{margin:0;padding-left:0}
.grp-vgl .rij{display:grid;grid-template-columns:230px 1fr 130px;gap:0 14px;align-items:center;padding:9px 0;border-bottom:1px solid #F1F2F4;transition:opacity .15s}
.grp-vgl .rij:last-child{border-bottom:0}
.grp-vgl .naam b{display:block;font:600 14px/1.25 var(--kop);color:var(--tekst)}
.grp-vgl .naam small{display:block;color:var(--gedempt);font-size:12px;margin-top:2px}
.grp-vgl .spoor{height:14px;background:#EEF0F2;border-radius:999px;overflow:hidden;box-shadow:inset 0 1px 2px rgba(26,29,35,.10)}
.grp-vgl .balk{display:block;height:100%;width:calc(var(--w) * 100%);min-width:6px;background:linear-gradient(90deg,#4B5563 0%,#1E3A5F 100%);border-radius:999px;box-shadow:0 1px 2px rgba(30,58,95,.35)}
.grp-vgl .waarde{font:700 14px/1.2 var(--kop);text-align:right;font-variant-numeric:tabular-nums;color:var(--tekst)}
.grp-vgl .chip{display:block;margin-top:3px;font-size:10.5px;font-weight:700;color:#B45309;text-transform:uppercase;letter-spacing:.06em}
.grp-vgl .chip[hidden]{display:none}
.grp-vgl .rij.op{opacity:.5}
.grp-vgl .rij.grp{padding:16px 18px;margin:0 -18px 12px;background:linear-gradient(135deg,var(--primair-licht) 0%,#F7FAF6 100%);border:1px solid rgba(45,90,39,.25);border-radius:16px;box-shadow:0 6px 16px rgba(45,90,39,.14)}
.grp-vgl .rij.grp .spoor{height:18px}
.grp-vgl .rij.grp .balk{background:linear-gradient(90deg,#3E7A36 0%,var(--primair) 100%);box-shadow:0 2px 6px rgba(45,90,39,.4)}
.grp-vgl .rij.grp .naam b{font-size:17px;color:var(--primair)}
.grp-vgl .rij.grp .waarde{font-size:20px;color:var(--primair)}
.grp-vgl .uitkomst{margin:22px 0 0;padding:16px 18px;background:var(--primair-zacht);border-left:4px solid var(--primair);border-radius:0 12px 12px 0;font:600 16px/1.5 var(--kop);color:var(--tekst)}
.grp-vgl .open{margin:40px 0 0}
.grp-vgl .open h3{margin:0 0 6px;font:700 22px/1.25 var(--kop);color:var(--tekst)}
.grp-vgl .open > p{margin:0 0 20px;max-width:44em;color:var(--gedempt);font-size:16px}
.grp-vgl .groepen{display:grid;grid-template-columns:repeat(3,1fr);gap:16px}
.grp-vgl .groep{background:var(--wit);border:1px solid var(--rand);border-top:4px solid var(--primair);border-radius:16px;padding:22px;box-shadow:0 4px 14px rgba(26,29,35,.06);transition:box-shadow .2s,transform .2s}
.grp-vgl .groep:hover{box-shadow:0 10px 24px rgba(26,29,35,.10);transform:translateY(-2px)}
.grp-vgl .groep h4{margin:0 0 8px;font:700 15px/1.3 var(--kop);color:var(--tekst)}
.grp-vgl .groep p{margin:0 0 12px;font-size:13.5px;color:var(--gedempt)}
.grp-vgl .groep .namen{margin:0;padding-top:12px;border-top:1px solid var(--rand);color:var(--tekst);font-size:14px;font-weight:600}
.grp-vgl details{margin-top:28px;background:var(--wit);border:1px solid var(--rand);border-radius:16px;padding:18px 22px;box-shadow:0 2px 8px rgba(26,29,35,.05)}
.grp-vgl summary{cursor:pointer;font:600 15px/1.3 var(--kop);color:var(--primair)}
.grp-vgl details p{margin:12px 0 0;font-size:14px;max-width:46em;color:var(--gedempt)}
.grp-vgl details p strong{color:var(--tekst)}
.grp-vgl .peil{margin:16px 0 0;color:var(--gedempt);font-size:12px;max-width:60em}
.grp-vgl .na{margin:40px 0 0;padding:32px;border-radius:20px;background:linear-gradient(135deg,var(--primair) 0%,var(--primair-donker) 100%);color:#fff;box-shadow:0 14px 34px rgba(45,90,39,.30),0 2px 6px rgba(0,0,0,.08)}
.grp-vgl .na h3{margin:0 0 8px;font:700 24px/1.25 var(--kop);color:#fff;max-width:24em}
.grp-vgl .na p{margin:0 0 22px;font-size:16px;color:rgba(255,255,255,.85);max-width:42em}
.grp-vgl .knop{display:inline-block;background:var(--accent);color:var(--tekst);border-radius:12px;padding:14px 28px;font:700 15px/1 var(--kop);text-decoration:none;box-shadow:0 6px 16px rgba(0,0,0,.20)}
.grp-vgl .knop:hover{background:#fff;color:var(--primair)}
.grp-vgl .knop:focus-visible,.grp-vgl input[type=range]:focus-visible{outline:3px solid var(--accent);outline-offset:3px}
@media (max-width:700px){
  .grp-vgl{padding:48px 16px}
  .grp-vgl .kaart,.grp-vgl .schuif{padding:20px 16px}
  .grp-vgl .na{padding:24px 18px}
  .grp-vgl .rij{grid-template-columns:1fr auto;gap:6px 12px}
  .grp-vgl .rij .spoor{grid-column:1 / -1;grid-row:2}
  .grp-vgl .rij.grp{margin:0 -8px 12px;padding:14px 10px}
  .grp-vgl .groepen{grid-template-columns:1fr}
}
@media (prefers-reduced-motion:reduce){.grp-vgl .rij,.grp-vgl .groep{transition:none}.grp-vgl .groep:hover{transform:none}}
`;

const GRP = { naam: 'GRP grafeen', sub: '15 jaar garantie · tot 3,65 per dag', w: '1', waarde: '20.000' };

const ANDEREN = [
  { naam: 'SMA Home Storage', sub: '10 jaar garantie · tot 1,97 per dag', dag: 1.97, w: '0.36', waarde: '7.200' },
  { naam: 'Enphase IQ Battery 5P', sub: '15 jaar garantie · tot 1,09 per dag', dag: 1.09, w: '0.3', waarde: '6.000' },
  { naam: 'EcoFlow PowerOcean', sub: '15 jaar garantie · tot 1,09 per dag', dag: 1.09, w: '0.3', waarde: '6.000' },
  { naam: 'Sessy', sub: '10 jaar garantie · tot 1,64 per dag', dag: 1.64, w: '0.3', waarde: '6.000' },
  { naam: 'Zonneplan', sub: '10 jaar garantie · tot 1,64 per dag', dag: 1.64, w: '0.3', waarde: '6.000' },
  { naam: 'EcoFlow OCEAN 2', sub: '15 jaar garantie · tot 0,80 per dag', dag: 0.8, w: '0.219', waarde: '4.380' },
  { naam: 'Huawei LUNA2000-S1', sub: '15 jaar garantie · tot 0,76 per dag', dag: 0.76, w: '0.209', waarde: '4.180' },
  { naam: 'Sigenergy SigenStor', sub: '10 jaar garantie · tot 0,99 per dag', dag: 0.99, w: '0.182', waarde: '3.640' },
  { naam: 'FoxESS EQ-serie', sub: '10 jaar garantie · tot 0,97 per dag', dag: 0.97, w: '0.1774', waarde: '3.548' },
  { naam: 'Huawei LUNA2000-S0', sub: '10 jaar garantie · tot 0,90 per dag', dag: 0.9, w: '0.1645', waarde: '3.290' },
  { naam: 'BYD Battery-Box Premium', sub: '10 jaar garantie · tot 0,82 per dag', dag: 0.82, w: '0.1505', waarde: '3.010' },
  { naam: 'Sungrow SBR', sub: '10 jaar garantie · tot 0,72 per dag', dag: 0.72, w: '0.13295', waarde: '2.659' },
  { naam: 'Anker SOLIX X1', sub: '10 jaar garantie · tot 0,72 per dag', dag: 0.72, w: '0.1317', waarde: '2.634' },
  { naam: 'GoodWe Lynx Home F Plus+', sub: '10 jaar garantie · tot 0,70 per dag', dag: 0.7, w: '0.128', waarde: '2.560' },
];

const fmt = (v) => v?.toFixed(1)?.replace('.', ',');

const GrpGarantieVergelijking = ({ ctaHref = '#adviesgesprek', ctaTekst = 'Plan een gratis adviesgesprek', onCtaClick }) => {
  const [dag, setDag] = useState(1);
  const n = ANDEREN?.length;
  const opCount = ANDEREN?.filter((r) => r?.dag < dag)?.length;

  return (
    <>
      <style>{GRP_VGL_CSS}</style>
      <section className="grp-vgl" aria-labelledby="grp-vgl-kop">
        <div className="binnen">
          <p className="label">Vergelijking · garantie in laadcycli</p>
          <h2 id="grp-vgl-kop">GRP garandeert minstens 20.000 cycli. Veertien andere thuisbatterijen stoppen tussen 2.560 en 7.200.</h2>
          <p className="intro">Een cyclus is één keer volledig laden en ontladen. Hoe meer cycli de fabrikant garandeert, hoe langer je batterij elke dag mee kan binnen de garantie. Hieronder staat wat elke aanbieder in zijn garantievoorwaarden toezegt, en wat GRP toezegt.</p>

          <div className="schuif" id="grp-schuif">
            <label htmlFor="grp-dag">Hoe vaak laad en ontlaad jij per dag?</label>
            <p className="uit">Schuif, en zie welke garanties jou nog dekken.</p>
            <div className="rij-schuif">
              <input
                id="grp-dag"
                type="range"
                min="0.5"
                max="3.5"
                step="0.1"
                value={dag}
                onChange={(e) => setDag(parseFloat(e?.target?.value))}
              />
              <output htmlFor="grp-dag" id="grp-dag-uit">{fmt(dag)} per dag</output>
            </div>
          </div>

          <figure className="kaart">
            <h3>Gegarandeerde volledige laadcycli</h3>
            <p className="sub">Per product, over de hele garantieperiode. Garanties in kWh zijn omgerekend naar volledige cycli.</p>
            <ol aria-label="Gegarandeerde cycli per aanbieder, van hoog naar laag">
              <li className="rij grp">
                <span className="naam"><b>{GRP?.naam}</b><small>{GRP?.sub}</small></span>
                <span className="spoor" aria-hidden="true"><span className="balk" style={{ '--w': GRP?.w }}></span></span>
                <span className="waarde">{GRP?.waarde}<span className="chip" hidden>dekt jou niet</span></span>
              </li>
              {ANDEREN?.map((r) => {
                const kort = r?.dag < dag;
                return (
                  <li key={r?.naam} className={kort ? 'rij op' : 'rij'}>
                    <span className="naam"><b>{r?.naam}</b><small>{r?.sub}</small></span>
                    <span className="spoor" aria-hidden="true"><span className="balk" style={{ '--w': r?.w }}></span></span>
                    <span className="waarde">{r?.waarde}<span className="chip" hidden={!kort}>dekt jou niet</span></span>
                  </li>
                );
              })}
            </ol>
            <p className="uitkomst" id="grp-uitkomst" aria-live="polite">
              {`Bij ${fmt(dag)} keer per dag zijn bij ${opCount} van de ${n} batterijen de gegarandeerde cycli op vóór het einde van de garantie. GRP dekt tot 3,65 keer per dag.`}
            </p>
          </figure>

          <div className="open">
            <h3>En de andere aanbieders?</h3>
            <p>Zeven aanbieders staan niet in de grafiek, omdat hun garantie geen aantal cycli of kWh noemt. Dit is wat ze wél toezeggen.</p>
            <div className="groepen">
              <div className="groep">
                <h4>Onbeperkt laden, onder voorwaarden</h4>
                <p>Geen cyclusgrens bij gewoon huishoudelijk gebruik. Er geldt wel een plafond zodra een derde partij de batterij aanstuurt of bij gebruik buiten eigen verbruik.</p>
                <p className="namen">Tesla Powerwall 3 (10 jaar) · SolarEdge Home Battery 400V (10 jaar)</p>
              </div>
              <div className="groep">
                <h4>Alleen jaren, geen prestatiegarantie</h4>
                <p>De garantie noemt een termijn, maar geen aantal cycli of kWh en geen percentage dat de batterij moet behouden.</p>
                <p className="namen">Zendure SolarFlow 2400 AC · AlphaESS SMILE-G3 · Pylontech Force H3 · Marstek Venus E</p>
              </div>
              <div className="groep">
                <h4>Plafond alleen bij een wederverkoper gepubliceerd</h4>
                <p>Wat de fabrikant zelf garandeert, is niet openbaar te vinden.</p>
                <p className="namen">Growatt APX HV 2.0</p>
              </div>
            </div>
          </div>

          <details>
            <summary>Hoe is dit berekend?</summary>
            <p><strong>Cyclusgarantie:</strong> het gegarandeerde aantal cycli. <strong>Doorzetgarantie:</strong> gegarandeerde kWh ÷ bruikbare capaciteit van de batterij. Heeft een product beide grenzen, dan telt de laagste. <strong>Per dag:</strong> cycli ÷ (garantiejaren × 365), afgekapt op twee decimalen.</p>
            <p><strong>GRP grafeen:</strong> minstens 20.000 cycli over 15 jaar garantie, is 3,65 cycli per dag.</p>
            <p><strong>Wat dit niet is:</strong> het contractuele minimum per aanbieder, niet de technische levensduur. Een batterij kan langer meegaan dan de garantie.</p>
          </details>
          <p className="peil">Peildatum 15 oktober 2026. Bron: garantievoorwaarden van de fabrikanten; GRP: opgave van GRP Energy.</p>

          <div className="na">
            <h3>Staat in jouw offerte hoeveel cycli worden gegarandeerd?</h3>
            <p>Veel offertes noemen het niet. Een adviseur van Verduurzaamwijzer.nu rekent het voor je door en zet het naast GRP.</p>
            <a className="knop" href={ctaHref} onClick={onCtaClick}>{ctaTekst}</a>
          </div>
        </div>
      </section>
    </>
  );
};

export default GrpGarantieVergelijking;
